import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IMyMonitoringAccountModel } from '@apps-common/types/portal/my-monitoring'

export const migrateMyMonitoringAccount = async (model: IMyMonitoringAccountModel): Promise<boolean> =>
  axios.post(`/MyMonitoringAccountManagement/MigrateAccount`, model).then((res) => res?.data?.result)

type Props = {
  model: IMyMonitoringAccountModel
}

export const useMigrateMyMonitoringAccount = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['migrateMyMonitoringAccount'],
    mutationFn: ({ model }: Props) => migrateMyMonitoringAccount(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Account migrated.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to migrate account.')
      }
    },
    throwOnError: false
  })
